<template>
  <div>
    <div
      class="d-block subtitle-2 font-weight-bold"
    >
      {{ title }}
    </div>
    <div
      class="d-block"
    >
      <div
        class="text-center"
      >
        <template
          v-for="(display, index) in displayValues(values)"
        >
          <div
            class="d-inline-block"
            :key="index"
          >
            <div
              class="d-block"
            >
              <div
                class="d-inline-block align-self-start text-h4 font-weight-bold pl-2"
              >
                {{ displayValue(display.value) }}
              </div>
              <div
                class="d-inline-block align-self-end text-caption font-weight-bold pl-1 pb-2"
              >
                <div
                  class="summary-unit-title"
                >
                  %
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div
      class="d-block"
    >
      <div
        class="align-baseline text-center"
      >
        <template
          v-for="(display, index) in displayValues(values)"
        >
          <div
            :class="['d-inline-block summary-legend-series', collapseStyle(display.value)]"
            :key="index"
          >
            <span class="text-caption">{{ display.name }}</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryMultiple',
  props: {
    /** カードのタイトル */
    title: {
      type: String
    },
    /** 表示値(name,value要素を持ったオブジェクトの配列であること) */
    values: {
      type: Array,
    },
  },
  computed: {
    /** 表示データ */
    displayValues: function() {
      return function (values) {
        if (!Array.isArray(values) || values.length <= 0) {
          return [{}]
        }
        let existsValues = values.find((row) => {
          // nullではない値を取得
          return (row && row.value !== null)
        })
        if (existsValues === undefined) {
          // すべてがnullである場合、
          return [{}]
        }
        return values
      }
    },
    displayValue: function () {
      return function (value) {
        if (value === undefined || value === null) {
          // undefined or nullは、ハイフン表示
          return '--'
        }
        return value
      }
    },
    collapseStyle: function () {
      return function (value) {
        return (value === undefined) ? 'collapse-style' : ''
      }
    },
  }
}
</script>
<style lang="scss" scoped>
  .summary-unit-title {
    line-height: 0.75rem;
  }
  .summary-legend-series::after {
    content: ":";
    padding-right: 4px;
    padding-left: 4px;
  }
  .summary-legend-series:last-child::after{
    content: "";
  }
</style>
